'use client';
import { jsx } from 'react/jsx-runtime';
import { useFloatingLabelTextInputElement } from '../../contexts/internal/floating-label/index.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { useFormFieldProps } from '../form/form.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)r = p[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)r = p[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const TextInput = renderWithRef('TextInput', null, (r, c)=>{
    useDeprecatedProps('TextInput', r, [
        {
            propName: 'size',
            instructions: 'Sizing is now handled automatically by standardMode/compactMode'
        }
    ]);
    let { children: s, size: a = 'standard', skin: u = 'standard', htmlSize: l } = r, b = _object_without_properties(r, [
        "children",
        "size",
        "skin",
        "htmlSize"
    ]), f = useId(b.id), d = useFloatingLabelTextInputElement(_object_spread_props(_object_spread({}, b), {
        id: f
    })), _ = useFormFieldProps(d.id), { 'aria-invalid': y } = _, O = new Set([
        'swan-input'
    ]);
    return ('error' === u || y) && O.add('swan-input-skin-error'), 'standard' !== a && O.add(`swan-input-${a}`), jsx(RenderComp, {
        root: "input",
        classNames: O,
        forwardedRef: c,
        props: _object_spread_props(_object_spread({}, d, _), {
            size: l
        }),
        children: s
    });
});

export { TextInput };
